import { Dispatch } from "redux";
import { resources } from "@constants/hardcoded-strings";
import { AxnCompany, AxnRelyingParty, SimpleAxnRpServiceWorkflow, SimpleAxnWorkflow } from "@idw-types/data/reference-data/axn";
import { RpServiceConfiguration } from "@idw-types/data/rp-service-configuration";
import { setPolicyComponentAssociatedPolicies, setPolicyComponentAssociatedPoliciesLoading } from "@redux/actions/policy-component-details-actions";
import { getPolicyComponentAffectedPoliciesRequest } from "@requests/service-configuration";
import { logAndDisplayErrorModal } from "@utils/app-alert-util";
import { formatPolicyComponentDetailsAssociatedPolicies } from "@formatters/policy-component-details/policy-component-details-associated-policies-formatter";

export const getPolicyComponentDetailsAssociatedPoliciesReduxRequest = (dispatch: Dispatch) => async (
    policyComponentId: string,
    axnAdminWorkflows: Array<SimpleAxnWorkflow>,
    simpleAXNRPServiceWorkflows: Array<SimpleAxnRpServiceWorkflow>,
    axnRelyingParties: Array<AxnRelyingParty>,
    axnCompanies: Array<AxnCompany>,
    axnRpServices: Array<RpServiceConfiguration>
) => {
    dispatch(setPolicyComponentAssociatedPoliciesLoading(true));

    const { data, error } = await getPolicyComponentAffectedPoliciesRequest(policyComponentId);

    if (data) {
        const formattedAssociatedPolicies = formatPolicyComponentDetailsAssociatedPolicies(
            data,
            axnAdminWorkflows,
            simpleAXNRPServiceWorkflows,
            axnRelyingParties,
            axnCompanies,
            axnRpServices
        );
        dispatch(setPolicyComponentAssociatedPolicies(formattedAssociatedPolicies));
        return formattedAssociatedPolicies;
    } else {
        if (error) {
            logAndDisplayErrorModal(
                dispatch,
                error,
                resources.requests.getAssociatedPolicies.error.title,
                resources.requests.getAssociatedPolicies.error.message,
                error
            );
        }
    }

    dispatch(setPolicyComponentAssociatedPoliciesLoading(false));
    return null;
};